import React, { forwardRef } from 'react'
import isArray from 'lodash/isArray'
import { AspectRatio } from '@chakra-ui/react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { graphql } from 'gatsby'

import Box from './Box'
import useWebpImage from './utils/useWebpImage'

const BGImage = ({ src, children, ...props }) => {
  const pic = useWebpImage(src)

  return (
    <Box backgroundImage={`url(${isArray(src) ? pic : src})`} {...props}>
      {children && <Box.FullAbs>{children}</Box.FullAbs>}
    </Box>
  )
}

BGImage.defaultProps = {
  backgroundSize: 'cover',
  backgroundPosition: '50% 50%',
  backgroundRepeat: 'no-repeat',
}

const BackgroundImage = forwardRef(
  (
    {
      src,
      image,
      children,
      backgroundSize,
      backgroundPosition,
      backgroundRepeat,
      alt,
      ...props
    },
    ref
  ) => (
    <AspectRatio {...props} ref={ref}>
      {image ? (
        <Box pos="relative">
          <GatsbyImage style={{ pointerEvents: 'none' }} image={image} alt={alt} />
          {children && <Box.FullAbs>{children}</Box.FullAbs>}
        </Box>
      ) : (
        <BGImage
          src={src}
          backgroundSize={backgroundSize}
          backgroundPosition={backgroundPosition}
          backgroundRepeat={backgroundRepeat}
        >
          {children}
        </BGImage>
      )}
    </AspectRatio>
  )
)

BackgroundImage.displayName = 'BackgroundImage'

export default BackgroundImage

export const query = graphql`
  fragment backgroundImage on File {
    name
    ext
    childImageSharp {
      gatsbyImageData
    }
  }
`
